module.exports = __webpack_public_path__ + "img/arg.d205ca13.svg";